import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import SiteSearch from '../../containers/site-search';
import MyMazda from '../../containers/my-mazda';
import './styles.css';
import BodyControl from "../../components/body";
import {DOCUMENT, WINDOW} from "../../constants/environment";

/**
 *  Header
 */
class Header extends Component {

  static logoSrc = 'data:image/png;base64,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';

  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    primaryNavigation: PropTypes.arrayOf(PropTypes.node),
    siteSearch: PropTypes.arrayOf(PropTypes.node),
    globalNavigation: PropTypes.arrayOf(PropTypes.node),
    myMazda: PropTypes.arrayOf(PropTypes.node),
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    primaryNavigation: null,
    siteSearch: null,
    globalNavigation: null,
    myMazda: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      close: this.props.close,
      open: this.props.open,
      height: 0,
      myMazdaOpened: null,
      myMazdaName: null,
    };
    this.open = this.props.open;
    //
    this.hostname = null;
    this.href = null;
    if (WINDOW && WINDOW.location && WINDOW.location.hostname && WINDOW.location.href) {
      this.hostname = WINDOW.location.hostname || null;
      this.href = WINDOW.location.href || null;
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    //
    if (this.props.myMazda !== null && 1 <= this.props.myMazda.length) {
      if (!this.props.myMazda[0].props.myMazdaLink.hideName) {
        // MyMazda ユーザID取得
        const uid = this.getUserId();
        if (uid && uid !== '') {
          // MyMazda Webログインユーザー氏名取得
          this.apiAccessLoginUserName(uid).then((value)=> {
            this.setState({
              myMazdaName: value,
            })
          });
        }
      }
    }
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  render() {
    return (
      <Wrapper
        containerId={this.props.containerId}
        containerClass={this.props.containerClass}
      >
        <div className="Header">
          <div className="Header__container">
            <div className="Header__layout">
              <div className="Header__layout-left" ref="heading">
                <div className="Header__heading">
                  <a href="/">
                    <img className="Header__heading-image"
                         src={Header.logoSrc}
                         alt="MAZDA"
                    />
                  </a>
                </div>
                <a
                  className={'Header__link-menu' + ((this.state.open === true || this.state.myMazdaOpened === true) ? ' open': '') + ((this.state.close === true || this.state.myMazdaOpened === false) ? ' close': '')}
                  href="#"
                  onClick={(e) => {
                    this.handleClick(e)
                  }}
                >
                  <span>
                    <span/>
                    <span/>
                    <span/>
                  </span>
                </a>
                {(this.props.myMazda !== null) ?
                  <div className={'Header__my-mazda-mb' + ((this.state.open === true) ? ' hide': '')}>
                    {this.props.myMazda.map((myMazda, index) => {
                      if (myMazda.type.displayName === 'MyMazda') {
                        return (
                          <MyMazda {...myMazda.props}
                                   key={index}
                                   onOpened={this.onOpenedMyMazda}
                                   onClosed={this.onClosedMyMazda}
                                   ref="myMazdaMb"
                                   myMazdaName={this.state.myMazdaName || null}
                          />
                        )
                      } else {
                        return null;
                      }
                    })}
                  </div>
                  : null}
              </div>
              {(() => {
                if (this.props.globalNavigation !== null || this.props.primaryNavigation !== null || this.props.siteSearch !== null || this.props.myMazda !== null) {
                  return (
                    <div className={'Header__layout-right' + ((this.state.open === true) ? ' open': '')}
                         style={{height: this.state.height}}
                    >
                      <div className='Header__layout-right-inner'
                           ref="layoutRight"
                      >
                        {(this.props.globalNavigation !== null) ?
                          <div className="Header__box">
                            {this.props.globalNavigation}
                          </div>
                          : null}
                        <div className="Header__layout2">
                          {(this.props.primaryNavigation !== null) ?
                            <div className="Header__layout2-left">
                              {this.props.primaryNavigation}
                            </div>
                            : null}
                          {(this.props.siteSearch !== null) ?
                            <div className="Header__layout2-center">
                              {this.props.siteSearch.map((siteSearch, index) => {
                                if (siteSearch.type.displayName === 'SiteSearch') {
                                  return (
                                    <SiteSearch {...siteSearch.props}
                                                scrollToSearchTop={this.scrollToSearchTop}
                                                key={index}
                                    />
                                  )
                                } else {
                                  return null;
                                }
                              })}
                            </div>
                            : null}
                          <div className="Header__layout2-right">
                            {(this.props.myMazda !== null) ?
                              <div className="Header__my-mazda-pc">
                                {this.props.myMazda.map((myMazda, index) => {
                                  if (myMazda.type.displayName === 'MyMazda') {
                                    return (
                                      <MyMazda {...myMazda.props}
                                               key={index}
                                               onOpened={this.onOpenedMyMazda}
                                               onClosed={this.onClosedMyMazda}
                                               ref="myMazdaPc"
                                               myMazdaName={this.state.myMazdaName || null}
                                      />
                                    )
                                  } else {
                                    return null;
                                  }
                                })}
                              </div>
                            : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  )
                } else {
                  return null;
                }
              })()}
            </div>
          </div>
        </div>
      </Wrapper>
    )
  }

  //
  onOpenedMyMazda = ()=> {
    this.setState({
      myMazdaOpened: true,
    })
  }

  //
  onClosedMyMazda = ()=> {
    this.setState({
      myMazdaOpened: false,
    })
  }

  //
  scrollToSearchTop = (targetTop) => {
    const scrollTop = this.refs.layoutRight.scrollTop;
    this.refs.layoutRight.scrollTo(0, targetTop + scrollTop);
  };

  //
  easing = (t, b, c, d) => {
    return c * ((t = t / d - 1) * t * t + 1) + b;
  };

  //
  handleClick = (e) => {
    e.preventDefault();

    //
    if (this.state.myMazdaOpened) {
      if (this.refs.myMazdaMb) {
        this.refs.myMazdaMb.close();
      }
      if (this.refs.myMazdaPc) {
        this.refs.myMazdaPc.close();
      }
      this.setState({
        myMazdaOpened: false,
      });
      //
      this.setState({
        height: 'auto',
      });
      // BODYのスクロール無効化を解除
      BodyControl.clearUnScroll();
      return;
    }

    //
    if (this.open === true) {
      this.open = false;
      this.setState({
        open: false,
        close: true,
      });
      //
      this.setState({
        height: 'auto',
      });
      // BODYのスクロール無効化を解除
      BodyControl.clearUnScroll();
    } else {
      this.open = true;
      this.setState({
        open: true,
        close: false,
      });
      window.scrollTo(0, 0);
      //
      this.handleResize();
      // BODYのスクロール無効化
      BodyControl.setUnScrollMb();
    }
  };

  //
  handleResize = () => {
    if (this.open === false) return;
    //
    if (window.matchMedia('(min-width:768px)').matches) {
      this.setState({
        height: 'auto',
      });
    } else {
      const top = document.documentElement.scrollTop || document.body.scrollTop;
      let height = window.innerHeight - this.refs.heading.clientHeight - top;
      this.setState({
        height: height,
      });
    }
  };

  // MyMazda Webログインユーザー氏名取得
  apiAccessLoginUserName = (uid)=> {
    return new Promise((resolve, reject)=> {
      if (!this.hostname || 0 <= String(this.hostname).indexOf('localhost')) {
        setTimeout(()=> {
          resolve('０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０');
          // resolve('０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９０１２３４５６７８９');
          // resolve('山田 太郎');
        }, 1000)
      } else {
        let url;
        // if (this.hostname && (0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev-mazda-co-jp') || 0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('uat-mazda-co-jp'))) {
        if (this.hostname && (0 <= String(this.hostname).indexOf('uat.mazda.co.jp') || 0 <= String(this.hostname).indexOf('dev.mazda.co.jp') || 0 <= String(this.hostname).indexOf('.test.mazda.jp'))) {
          url = 'https://my-mazda-co-jp.test.mazda.jp/api/v1/loginUserName';
        } else {
          url = 'https://my.mazda.co.jp/api/v1/loginUserName';
        }
        //
        const params = new URLSearchParams();
        params.set('id', uid);
        //
        console.log('apiAccessLoginUserName', url + '?' + params.toString());
        fetch(url + '?' + params.toString(), {
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded',
            // 'Content-Type': 'application/json',
          },
          method: 'GET',
          mode: 'cors',
          credentials: 'include',
        }).then((response) => {
          return response.json();
        }).then((json) => {
          console.log('success', json);
          if (json.status === 'LOGIN' || json.status === 'APP_LOGIN') {
            resolve(json.lastName + ' ' + json.firstName);
          } else {
            reject();
          }
        }).catch((e) => {
          console.log('error', e.message);
          reject();
        });
      }
    });
  }

  // ユーザID取得
  getUserId = ()=> {
    if(!DOCUMENT || !DOCUMENT.cookie){
      return false;
    }
    const cookies = document.cookie;
    const arr = cookies.split(';');
    for(var c of arr){
      var arr2 = c.split('=');
      if(arr2[0].match(/\mmuid/)) {
        return arr2[1];
      }
    }
  }

}

export default Header;



// WEBPACK FOOTER //
// ./src/containers/header/index.jsx